import { Component, Inject, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AddressService } from '../service/address/address.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import {
  catchError,
  debounceTime,
  distinctUntilChanged,
  map,
  startWith,
  switchMap,
} from 'rxjs/operators';
import { merge, of as observableOf } from 'rxjs';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-search-list',
  templateUrl: './search-list.component.html',
  styleUrls: ['./search-list.component.css'],
})
export class SearchListComponent implements OnInit, AfterViewInit {
  dataSource = new MatTableDataSource();
  defaultResponse = [];
  displayedColumns: string[] = [
    'NickName',
    'CompanyName',
    'ContactPersonName',
    'AddressLine1',
    'CityName',
    'PostalCode',
    'CountryCode',
  ];
  searchItems: any = [];
  defaultItems: any = [];
  openedFrom: string = '';
  @ViewChild('paginator') paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  pageSizes = [5, 10, 15];
  totalData;
  searchKeywordFilter = new FormControl();
  constructor(
    private addressService: AddressService,
    public dialogRef: MatDialogRef<SearchListComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { openedFrom: string }
  ) {}

  ngOnInit(): void {
    this.getSearchItems();
    this.filterBySearch();
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  getAddressData(openedFrom) {
    const requestData = {
      query: {
        address_type: [openedFrom],
      },
      limit: this.paginator.pageSize,
      page: 1,
      search: this.searchKeywordFilter.value == null ? '' : this.searchKeywordFilter.value,
      sort: this.sort.active,
      sortOrder: this.sort.direction === 'desc' ? -1 : 1,
    };
    this.addressService.getAddressList(requestData).subscribe(response => {
      this.assignDataSource(response);
    });
  }

  assignDataSource(response) {
    this.totalData = response.totalCount ? response.totalCount : 0;
    this.dataSource = new MatTableDataSource(response.data);
    this.defaultResponse = response.data;
    this.defaultItems = this.searchItems = this.formatAddressList(response.data, this.openedFrom);
    this.dataSource.data = this.searchItems;
  }

  getSearchItems() {
    this.openedFrom = this.data ? this.data?.openedFrom : '';
    // this.openedFrom && this.getAddressData(this.openedFrom);
  }

  selectedAddress(id) {
    this.dialogRef.close(this.defaultResponse.find(address => address?.address_id === id));
  }

  filterBySearch() {
    this.searchKeywordFilter.valueChanges
      .pipe(debounceTime(800), distinctUntilChanged())
      .subscribe(() => {
        this.getAddressData(this.openedFrom);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      });
  }

  formatAddressList(address_list_details, addressType) {
    const address_type = addressType.toLowerCase();
    return address_list_details.map(address => ({
      address_id: address.address_id,
      companyName: address.address_details[`${address_type}CompanyName`],
      contactPersonName: address.address_details[`${address_type}ContactPersonName`],
      addressLine1: address.address_details[`${address_type}AddressLine1`],
      addressLine2: address.address_details[`${address_type}AddressLine2`],
      addressLine3: address.address_details[`${address_type}AddressLine3`],
      cityName: address.address_details[`${address_type}CityName`],
      postalCode: address.address_details[`${address_type}PostalCode`],
      countryCode: address.address_details[`${address_type}CountryCode`],
      countryName: address.address_details[`${address_type}CountryName`],
      email: address.address_details[`${address_type}Email`],
      phone: address.address_details[`${address_type}Phone`],
      mobilePhone: address.address_details[`${address_type}MobilePhone`],
      nickName: address.address_details[`${address_type}NickName`],
    }));
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;

    this.sort.sortChange.subscribe(() => (this.paginator.pageIndex = 0));
    merge(this.sort.sortChange, this.paginator.page)
      .pipe(
        startWith({}),
        switchMap(() => {
          const requestData = {
            query: {
              address_type: [this.openedFrom],
            },
            limit: this.paginator.pageSize,
            page: this.paginator.pageIndex + 1,
            search: this.searchKeywordFilter.value == null ? '' : this.searchKeywordFilter.value,
            sort:
              this.sort.active === 'addressValidated'
                ? this.sort.active
                : this.sort.active
                ? this.openedFrom.toLowerCase().concat(this.sort.active)
                : '',
            sortOrder: this.sort.direction === 'desc' ? -1 : 1,
          };

          return this.addressService
            .getAddressList(requestData)
            .pipe(catchError(() => observableOf(null)));
        }),
        map(empData => {
          if (empData == null) {
            this.totalData = 0;
            return [];
          }
          return empData;
        })
      )
      .subscribe(empData => {
        this.assignDataSource(empData);
      });
  }
}
